export default {
  login: "/login",
  register_facility: "/register-facility",
  change_password: "/change-password",
  notFound: "/notFound"
};
